(() => {
  if (window.addaxPriceSliderLoaded) return;
  window.addaxPriceSliderLoaded = true;

  const numberValue = (value, fallback = 0) => {
    const parsed = Number.parseFloat(String(value || '').replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const formatPrice = (value, currency) => {
    const rounded = Math.round(value * 100) / 100;
    return `${currency}${Number.isInteger(rounded) ? rounded : rounded.toFixed(2)}`;
  };

  const parts = (slider) => ({
    minRange: slider.querySelector('[data-price-range="min"]'),
    maxRange: slider.querySelector('[data-price-range="max"]'),
    minNumber: slider.querySelector('[data-price-number="min"]'),
    maxNumber: slider.querySelector('[data-price-number="max"]'),
    minOutput: slider.querySelector('[data-price-output="min"]'),
    maxOutput: slider.querySelector('[data-price-output="max"]'),
    rail: slider.querySelector('.price-slider__rail'),
  });

  const paint = (slider) => {
    const p = parts(slider);
    if (!p.minRange || !p.maxRange || !p.rail) return;

    const maximum = Math.max(numberValue(p.maxRange.max, 1), 1);
    const minimumGap = Math.min(1, maximum);
    let minimumValue = numberValue(p.minRange.value, 0);
    let maximumValue = numberValue(p.maxRange.value, maximum);

    if (minimumValue > maximumValue - minimumGap) {
      minimumValue = Math.max(0, maximumValue - minimumGap);
    }
    if (maximumValue < minimumValue + minimumGap) {
      maximumValue = Math.min(maximum, minimumValue + minimumGap);
    }
    p.minRange.value = minimumValue;
    p.maxRange.value = maximumValue;

    p.rail.style.setProperty('--price-min', `${(minimumValue / maximum) * 100}%`);
    p.rail.style.setProperty('--price-max', `${(maximumValue / maximum) * 100}%`);

    const currency = slider.dataset.currency || '£';
    p.minOutput.textContent = formatPrice(minimumValue, currency);
    p.maxOutput.textContent = formatPrice(maximumValue, currency);
  };

  const initialise = (root = document) => {
    root.querySelectorAll?.('[data-price-slider]').forEach((slider) => {
      if (slider.dataset.priceSliderReady) return;
      slider.dataset.priceSliderReady = 'true';
      paint(slider);
    });
  };

  document.addEventListener(
    'input',
    (event) => {
      const range = event.target.closest?.('[data-price-range]');
      if (range) {
        event.stopPropagation();
        const slider = range.closest('[data-price-slider]');
        const p = parts(slider);
        const maximum = Math.max(numberValue(p.maxRange.max, 1), 1);
        const minimumGap = Math.min(1, maximum);

        if (
          range.dataset.priceRange === 'min' &&
          numberValue(range.value) > numberValue(p.maxRange.value) - minimumGap
        ) {
          range.value = Math.max(0, numberValue(p.maxRange.value) - minimumGap);
        }
        if (
          range.dataset.priceRange === 'max' &&
          numberValue(range.value) < numberValue(p.minRange.value) + minimumGap
        ) {
          range.value = Math.min(maximum, numberValue(p.minRange.value) + minimumGap);
        }

        p.minRange.style.zIndex = range.dataset.priceRange === 'min' ? '5' : '3';
        p.maxRange.style.zIndex = range.dataset.priceRange === 'max' ? '5' : '4';

        paint(slider);
        return;
      }

      const numberInput = event.target.closest?.('[data-price-number]');
      if (!numberInput) return;

      const slider = numberInput.closest('[data-price-slider]');
      const p = parts(slider);
      const maximum = numberValue(p.maxRange.max, 0);
      const minimumGap = Math.min(1, maximum);

      if (numberInput.dataset.priceNumber === 'min') {
        p.minRange.value = Math.min(
          Math.max(numberValue(numberInput.value, 0), 0),
          Math.max(0, numberValue(p.maxRange.value) - minimumGap)
        );
      } else {
        p.maxRange.value = Math.max(
          Math.min(numberValue(numberInput.value, maximum), maximum),
          numberValue(p.minRange.value) + minimumGap
        );
      }
      paint(slider);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const range = event.target.closest?.('[data-price-range]');
    if (!range) return;

    const slider = range.closest('[data-price-slider]');
    const p = parts(slider);
    const numberInput = range.dataset.priceRange === 'min' ? p.minNumber : p.maxNumber;
    const maximum = numberValue(p.maxRange.max, 0);
    const value = numberValue(range.value, 0);

    numberInput.value =
      range.dataset.priceRange === 'min' && value === 0
        ? ''
        : range.dataset.priceRange === 'max' && value === maximum
          ? ''
          : value;

    numberInput.dispatchEvent(new Event('input', { bubbles: true }));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) =>
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initialise(node);
      })
    );
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
